import React from "react";

import { useMutation, useQuery } from "@apollo/client";
import { useRouteMatch } from "react-router-dom";

import RbGrid from "components/RbGrid";
import RbTextField from "components/RbTextField";
import {
  createProductCategoryMutation,
  updateProductCategoryMutation,
  productCategoryQuery,
  productCategoryListQuery,
} from "graphql/productCategory";
import { createSortByProp } from "utils/sortUtils";

import BaseForm from "./BaseForm";

function ProductCategoryForm() {
  const { path } = useRouteMatch();
  const match = useRouteMatch(`${path}/:idParam`);
  const idParam = match?.params?.idParam;

  const { data: { productCategory } = {} } = useQuery(productCategoryQuery, {
    variables: {
      id: idParam,
    },
    skip: !idParam || idParam === "new",
  });

  const [createRow] = useMutation(createProductCategoryMutation, {
    update(cache, result) {
      const { productCategoryList } = cache.readQuery({
        query: productCategoryListQuery,
      });
      const data = {
        productCategoryList: [
          result.data.createProductCategory,
          ...productCategoryList,
        ].sort(createSortByProp("name")),
      };
      cache.writeQuery({
        query: productCategoryListQuery,
        data,
      });
    },
  });

  const [updateRow] = useMutation(updateProductCategoryMutation);

  return (
    <BaseForm
      row={productCategory}
      createPromise={createRow}
      updatePromise={updateRow}
      title="category"
    >
      <RbGrid item xs={12}>
        <RbTextField fieldName="name" label="Name" required />
      </RbGrid>
    </BaseForm>
  );
}

export default React.memo(ProductCategoryForm);
